import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';
import US from 'country-flag-icons/react/3x2/US';
import CN from 'country-flag-icons/react/3x2/CN';
import FR from 'country-flag-icons/react/3x2/FR';
import ES from 'country-flag-icons/react/3x2/ES';
import KR from 'country-flag-icons/react/3x2/KR';
import JP from 'country-flag-icons/react/3x2/JP';
import AE from 'country-flag-icons/react/3x2/AE';
import RU from 'country-flag-icons/react/3x2/RU';
import IN from 'country-flag-icons/react/3x2/IN';

const languages = [
  { code: 'en', name: 'English', Flag: US, countryCode: 'US' },
  { code: 'zh', name: '中文', Flag: CN, countryCode: 'CN' },
  { code: 'fr', name: 'Français', Flag: FR, countryCode: 'FR' },
  { code: 'es', name: 'Español', Flag: ES, countryCode: 'ES' },
  { code: 'ko', name: '한국어', Flag: KR, countryCode: 'KR' },
  { code: 'ja', name: '日本語', Flag: JP, countryCode: 'JP' },
  { code: 'ar', name: 'العربية', Flag: AE, countryCode: 'AE' },
  { code: 'ru', name: 'Русский', Flag: RU, countryCode: 'RU' },
  { code: 'hi', name: 'हिंदी', Flag: IN, countryCode: 'IN' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // 根据当前语言获取选中的语言对象
  const getCurrentLanguage = () => {
    return languages.find(lang => lang.code === i18n.language) || languages[0];
  };

  const [selectedLanguage, setSelectedLanguage] = useState(getCurrentLanguage());

  useEffect(() => {
    // 当 i18n 语言变化时更新选中状态
    setSelectedLanguage(getCurrentLanguage());
  }, [i18n.language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language.code); // 切换语言
    setIsOpen(false);
  };

  return (
    <div className="language-selector-container" ref={dropdownRef}>
      <div
        className="language-selector-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="trigger-flag-icon">
          {React.createElement(selectedLanguage.Flag, { className: 'flag-svg' })}
        </div>
        <span className="chevron-down">▼</span>
      </div>
      {isOpen && (
        <div className="language-dropdown">
          {languages.map((language) => (
            <div
              key={language.code}
              className={`language-item ${
                selectedLanguage.code === language.code ? 'active' : ''
              }`}
              onClick={() => handleLanguageSelect(language)}
            >
              <div className="language-icon">
                {React.createElement(language.Flag, { className: 'flag-svg' })}
              </div>
              <span className="language-name">{language.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;

